export default {
    global: {
        lang: '',
        path: '',
        query:[],
        accountType: '',
        isPremier: false
    }
}
